<template>
    <div class="product">
        <navBar></navBar>
        <!--<div class="p-video" @click="videoPlay">
            <img class="play-btn" src="https://restaskimg.civaonline.cn/imagesH5/product/play-btn.png" alt="" v-if="!videoStatus">
        </div>-->
        <div class="p-video"></div>
        <div class="p-items">
            <div class="p-item p-item-stu" @click="goPage('student')">
                <div class="p-text">
                    <h5 class="p-text-title">我是学生</h5>
                    <p class="p-text-intro">高效学习，快乐成长<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-tea" @click="goPage('teacher')">
                <div class="p-text">
                    <h5 class="p-text-title">我是老师</h5>
                    <p class="p-text-intro">上课轻松，成长迅速<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-p" @click="goPage('parent')">
                <div class="p-text">
                    <h5 class="p-text-title">我是家长</h5>
                    <p class="p-text-intro">贴心督学，成长紧跟随<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-s" @click="goPage('schoolmaster')">
                <div class="p-text">
                    <h5 class="p-text-title">我是校长</h5>
                    <p class="p-text-intro">运营全掌握，办学更轻松<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item-view">
                <div class="p-item p-item-t" @click="goPage('doubleteacher')">
                    <div class="p-text">
                        <h5 class="p-text-title">双师课堂</h5>
                        <p class="p-text-intro">双师授课，教学支撑<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                    </div>
                </div>
            </div>
        </div>
        <!--视频播放弹框-->
        <!--<div class="video-popup-box" v-show="popupVisible" @click="popupClose">
            <div class="popup">
                <video class="play-video" ref="videoPlay" preload="auto" controls="controls" poster="https://restaskimg.civaonline.cn/imagesH5/product/student-banner.png">
                    <source src="https://restaskimg.civaonline.cn/static/video/home.mp4" type="video/mp4">
                </video>
            </div>
        </div>-->
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
  data() {
    return {
      videoStatus: false,
      popupVisible: false,
    }
  },
  methods: {
    // 弹框显示视频播放
    /* videoPlay() {
      if (!this.videoStatus){
        this.videoStatus = true;
        this.popupVisible = true;
        this.$refs.videoPlay.play();
      }
    },*/
    // 弹框关闭视频暂停
    /* popupClose() {
      this.$refs.videoPlay.pause();
      this.videoStatus = false;
      this.popupVisible = false;
    },*/
    // 跳转对应产品页面
    goPage(name) {
      this.$router.push({ name: name });
    },
  },
}
</script>

<style scoped lang="less">
.product{
    .p-video{
        position: relative;
        width: 100%;
        height: 468px;
        background: url("https://restaskimg.civaonline.cn/imagesH5/p-banner.png") no-repeat center center / cover;
        /*.play-btn{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 143px;
        }
        .play-video{
            width: 100%;
            height: 468px;
        }*/
    }
    .p-items{
        padding: 26px 20px 25px;
        .p-item{
            margin-bottom: 8px;
            width: 100%;
            height: 224px;
            background: url("https://restaskimg.civaonline.cn/imagesH5/product/student-p.png") no-repeat center center / cover;
        }
        .p-item-tea{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/product/teacher-p.png");
        }
        .p-item-p{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/product/parent-p.png");
        }
        .p-item-s{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/product/schoolmaster-p.png");
        }
        .p-item-view{
          width: 100%;
          padding: 6px 12px 18px;
          box-sizing: border-box;
          height: 224px;
        }
        .p-item-t{
          background-image: url("https://restaskimg.civaonline.cn/imagesH5/double-tea.png");
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(255,171,178,0.5);
          margin: 6px 0 18px;
          height: 200px;
          box-sizing: border-box;
        }
        .p-text{
            color: #FFFFFF;
            font-family: SyMedium;
            margin-left: 60px;
            padding-top: 52px;
        }
        .p-text-title{
            font-size: 42px;
            line-height: 60px;
            font-weight: 500;
        }
        .p-text-intro{
            font-size: 30px;
            line-height: 42px;
            margin-top: 6px;
            img{
                width: 14px;
                margin-left: 20px;
            }
        }
    }
}
</style>
